import { stateOptions } from '../../commonStateTaxData';

export const basicInfoQuestions2023 = [
  {
    id: 'employee_name',
    title: 'Full name',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'employee_ssn',
    title: 'Social Security number',
    is_required: true,
    placeholder: '9 digits',
    question_type: 'identity',
    identity_type: 'ssn',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^\\d{9}$',
      },
    ],
  },
  {
    id: 'street_address',
    title: 'Home address - number and street or rural route',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'city_or_town',
    title: 'City or town',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'state',
    title: 'State',
    is_required: true,
    question_type: 'dropdown',
    options: stateOptions,
  },
  {
    id: 'zip_code',
    title: 'Zip code',
    is_required: true,
    question_type: 'short_text',
    placeholder: '5 digits',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^\\d{5}$',
      },
    ],
  },
];

export const withholdingQuestions2023 = [
  {
    id: 'percent_withheld',
    title: 'Withhold from gross taxable wages at the selected percentage: ',
    is_required: true,
    question_type: 'multiple_choice',
    options: [
      {
        codeValue: '05_percent',
        shortName: '0.5%',
      },
      {
        codeValue: '10_percent',
        shortName: '1.0%',
      },
      {
        codeValue: '15_percent',
        shortName: '1.5%',
      },
      {
        codeValue: '20_percent',
        shortName: '2.0%',
      },
      {
        codeValue: '25_percent',
        shortName: '2.5%',
      },
      {
        codeValue: '30_percent',
        shortName: '3.0%',
      },
      {
        codeValue: '35_percent',
        shortName: '3.5%',
      },
    ],
  },
  {
    id: 'extra_withholding',
    title: 'Extra amount to be withheld from each paycheck: ',
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^(0|[1-9][0-9]*)$',
      },
    ],
  },
];
